<div class="advertisement_details_slides">
    <div class="other_details">
        <div class="container">
            <div class="wrap_other_details">
                <owl-carousel-o [options]="OwlCarousel">
                    <ng-container *ngFor="let item of Tabs">
                        <ng-template [width]="200" carouselSlide [id]="item.id">
                            <div 
                                (click)="ChangeContentView(item.id)"
                                [ngClass]="{'active': item.id == CurrentTabActive}"
                                class="item_other_details text-white border_r text_sm_bold text-center pointer"
                            >
                              {{item?.name}}
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>
        </div>
        <div class="custom_container">
            <div class="wrap_all_items pb-0 d-flex flex-wrap align-items-center justify-content-center justify-content-sm-start">
                <ng-container *ngFor="let item of ListOfDetails">
                    <div 
                        class="item_box text-center d-flex flex-column align-items-center justify-content-center"
                        [ngClass]="{'item_box_ads_file': CurrentTabActive == OTHER_DETAILS_TYPE.Designs}"
                    >
                        <ng-container *ngIf="CurrentTabActive != OTHER_DETAILS_TYPE.Designs; else Designs">
                            <a *ngIf="item?.link" [href]="item?.link" class="a_none d-block" target="_blank">
                                <ng-container *ngTemplateOutlet="itemBox"></ng-container>
                            </a>
                            <ng-container *ngIf="!item?.link" >
                                <ng-container *ngTemplateOutlet="itemBox"></ng-container>
                            </ng-container>
                            <ng-template #itemBox>
                                <img [src]="item?.img" [alt]="item?.name" appImgUrlCheck/>
                                <span class="d-block item_text label_lg_bold">{{item?.name}}</span>
                                <span *ngIf="item?.type == FEATURES_TYPE.list" class="d-block item_value label_lg_bold main_color_4th">{{item?.optionName}}</span>
                                <span *ngIf="item?.type == FEATURES_TYPE.number" class="d-block item_value label_lg_bold main_color_4th">{{item?.value || 0}}</span>
                            </ng-template>
                        </ng-container>
                        <ng-template #Designs>
                            <a [href]="item?.link" class="a_none d-block" target="_blank">
                                <img src="/assets/img/ads_file_img.svg" alt="File" />
                                <span class="item_file_text text_sm_bold main_color d-block padding_top_2">{{item?.name}}</span>
                            </a>
                        </ng-template>
                    </div>
                </ng-container>
                <p class="label_lg_bold text-center color_wrong" *ngIf="ListOfDetails?.length == 0">لم يتم اضافة التفاصيل</p>
            </div>
        </div>
    </div>
</div>